import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { initializeTokapiAxiosInstance } from '@workspace/frontend-kit'
import { setTokapiAxiosInstance } from '@toktokdoctech/tokapi-client'
import './app/assets/css/index.css'
import './app/assets/css/fonts.css'
import { Provider } from 'react-redux'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole } from '@sentry/integrations'
import * as Sentry from '@sentry/react'
import { tanstackQueryClient } from './app/api/tanstackClient'
// import FlagProvider, { UnleashClient } from '@unleash/proxy-client-react'
import packageJson from '../package.json'
import * as serviceWorker from './app/serviceWorker'
import App from './app/App'
import ErrorBoundary from './app/components/Common/ErrorBoundary'
import { store } from './app/store'
import idsTheme from './app/theme/idsTheme'
// import unleashConfig from './app/config/flagProvider'

/* SETUP SENTRY ON STG AND PROD  */
if (!window.location.host.includes('localhost')) {
    console.log('[APP] Sentry enabled')
    Sentry.init({
        dsn: 'https://41dc5638b8bc4ebe9be67028706266b6@o159636.ingest.sentry.io/5832469',
        integrations: [
            new Integrations.BrowserTracing(),
            new CaptureConsole({
                levels: ['error'],
            }),
        ],
        environment: window._env_.REACT_APP_TTD_ENV,
        release: `ids_${packageJson.version}`,
        tracesSampleRate: 1.0,
    })
} else {
    console.log('[APP] Sentry disabled reason: local env')
}

const tokapiUrl = window._env_.REACT_APP_TOKAPI_IDS || ''
const authRedirectUrl = `${window._env_.REACT_APP_HDS_HOST}/login?redirect=${window._env_.REACT_APP_CUR_AUTH_CLBC}`
const tokapiAxiosInstance = initializeTokapiAxiosInstance(tokapiUrl, authRedirectUrl)
setTokapiAxiosInstance(tokapiAxiosInstance)

const theme = idsTheme()

// new way to create app since react v18
const container = document.getElementById('app')
// @ts-expect-error TS(2345) FIXME: Argument of type 'HTMLElement | null' is not assig... Remove this comment to see the full error message
const root = createRoot(container) // createRoot(container!) if you use TypeScript

// const unleashClient = new UnleashClient(unleashConfig)
// const startUnleashClient = window._env_.REACT_APP_TTD_ENV === 'production'

root.render(
    <Provider store={store}>
        {/* <FlagProvider unleashClient={unleashClient} startClient={startUnleashClient}> */}
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <ErrorBoundary>
                    <QueryClientProvider client={tanstackQueryClient}>
                        <App />
                    </QueryClientProvider>
                </ErrorBoundary>
            </ThemeProvider>
        </StyledEngineProvider>
        {/* </FlagProvider> */}
    </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
